import React, { createContext, useContext, useState, useEffect } from "react";
import { getUserData, getAccessToken } from "../Helpers/authHelper";
import axios from "axios";
import useApi from "../Hooks/useApi";

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { request } = useApi();
  useEffect(() => {
    const fetchPermissions = async () => {
      const userData = getUserData();
      const accessToken = getAccessToken();

      if (userData && accessToken) {
        try {
          const response = await request("GET", `/v1/rbac/users/permissions`);
          setUserPermissions(response);
        } catch (error) {
          console.error("Error fetching permissions:", error);
          // If there's an error, we'll set permissions to an empty array
          setUserPermissions([]);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);

  const hasPermission = (permissionName) => {
    const isSuperAdmin = userPermissions.some((permission) => permission.name === "Super Admin");
  
    if (isSuperAdmin && permissionName === "IMIS Data Insertion") {
      return false; // Hide IMIS Data Insertion for Super Admin
    }
  
    return userPermissions.some((item) => item.name === permissionName);
  };
  

  return (
    <PermissionContext.Provider
      value={{ permissions: userPermissions, hasPermission, loading }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext);
